import { useGT } from 'gt-react';
import type { WorkbookDefinition } from '@erp/shared-types';
import {
  matchSheetKind,
  resultColumns,
  type ExecutionRoot,
} from '@erp/workbooks';
import type { WorkbookReferenceLabels } from './useWorkbookReferences';

/** What an Execution root with no Instructions does, from its configuration. */
export function WorkbookStepDescription({
  definition,
  references,
  root,
}: {
  definition: WorkbookDefinition;
  references: WorkbookReferenceLabels;
  root: ExecutionRoot;
}) {
  const gt = useGT();
  const sheet = definition.sheets.find((item) => item.id === root.itemId);
  if (!sheet) return null;
  const columns = resultColumns(sheet)
    .map((column) => column.name)
    .join(', ');
  const description = matchSheetKind(sheet, {
    columnar: ({ inputId }) =>
      gt('Use {input} to produce {columns}.', {
        context: 'workbook simple worksheet description',
        input: references.name(inputId),
        columns,
      }),
    pivot: ({ inputId }) =>
      gt('Summarize {input} into {columns}.', {
        context: 'workbook simple pivot description',
        input: references.name(inputId),
        columns,
      }),
    freeform: () =>
      gt('Calculate {columns} in a grid.', {
        context: 'workbook simple freeform description',
        columns,
      }),
  });
  return (
    <p className="line-clamp-2 pl-6 text-sm text-muted-foreground">
      {description}
    </p>
  );
}
